<template>
  <BaseModal overlay-class="postgame">
    <div class="content">
      <BaseImage
        src="/static/images/postgame_stars.svg"
        class="top_img"
        alt="Stars"
      />

      <h1>{{ $_translations.value.modal_post_game_title }}</h1>

      <p>{{ $_translations.value.modal_post_game_subtitle }}</p>

      <RewardBoxItem :prize-value="info.prizeValue" />

      <div class="postgame_stats">
        <div class="flex-column">
          <h3>{{ info.totalQuestions }}</h3>

          <p>{{ $_translations.value.modal_post_game_questions_total }}</p>
        </div>

        <div class="divider_vert"></div>

        <div class="flex-column">
          <h3 class="correct">{{ info.correctAnswers }}</h3>

          <p>{{ $_translations.value.modal_post_game_answers_correct }}</p>
        </div>

        <div class="flex-column">
          <h3 class="wrong">{{ info.wrongAnswers }}</h3>

          <p>{{ $_translations.value.modal_post_game_answers_wrong }}</p>
        </div>
      </div>

      <BaseButton
        v-if="hasAvailableGames"
        @click:button="$emit('start:newGame')"
      >
        {{ $_translations.value.modal_post_game_button_play }}
      </BaseButton>

      <BaseButton
        v-else-if="!appSettingsStore.isStoreDisabled"
        @click:button="$emit('redirect:storePage')"
      >
        {{ $_translations.value.modal_post_game_button_games }}
      </BaseButton>

      <BaseButton
        v-else
        @click:button="$emit('redirect:homePage')"
      >
        {{ $_translations.value.modal_post_game_button_home }}
      </BaseButton>

      <div class="flex-row">
        <div class="bg_border games">
          <div class="flex-row">
            <BaseImage :src="availableGamesImage" alt="Games" />

            <p>{{ info.availableGames }}</p>
          </div>
        </div>

        <p>{{ $_translations.value.modal_post_game_available_games }}</p>
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue';
import { Howl } from 'howler';
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseButton from '@/components/button/BaseButton.vue';
import RewardBoxItem from '@/components/item/RewardBoxItem.vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useConfettiHook from '@/hooks/useConfetti.js';
import { gamesImage, gamesZeroImage } from '@/constants/image.js';

defineEmits([
  'start:newGame',
  'redirect:storePage',
  'redirect:homePage',
]);

const props = defineProps({
  info: {
    type: Object,
    default: () => ({
      totalQuestions: 0,
      correctAnswers: 0,
      wrongAnswers: 0,
      prizeValue: 0,
      availableGames: 0,
    }),
  },
});

const appSettingsStore = useAppSettingsStore();

const { triggerConfetti, clearConfetti } = useConfettiHook();

const hasAvailableGames = computed(() => props.info.availableGames > 0);

const availableGamesImage = computed(() => hasAvailableGames.value ? gamesImage : gamesZeroImage);

onMounted(() => {
  triggerConfetti();

  if (appSettingsStore.isSoundEnabled) {
    const modalSound = new Howl({ src: ['/static/sounds/postgame.mp3'] });
    modalSound.play();
  }
});

onUnmounted(clearConfetti);
</script>
